import { create } from "zustand";
import { User } from "../types";
import { devtools, persist } from "zustand/middleware";

interface AuthState {
  user: User | null;
  sessionExpiryDate: string | null;
  setUser: (user: User | null) => void;
  setSessionExpiryDate: (expiryDate: string | null) => void;
  sessionExpiryModalOpened: boolean;
  setSessionExpiryModalOpened: (state: boolean) => void;
}

export const useSessionStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        sessionExpiryDate: null,
        sessionExpiryModalOpened: false,
        setUser: (user: User | null) => {
          set(() => ({ user: user }));
        },
        setSessionExpiryDate: (expiryDate: string | null) => {
          set(() => ({ sessionExpiryDate: expiryDate }));
        },
        setSessionExpiryModalOpened: (state: boolean) => {
          set(() => ({ sessionExpiryModalOpened: state }));
        },
      }),
      {
        name: "auth-storage",
      }
    )
  )
);
